














































































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { Checkbox, FormItem, Input, Option, OptionGroup, Select, Radio, RadioGroup } from 'element-ui';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import { SelectOption } from '@/types/types';

import { customerInsuranceOptions } from '@/constants/customerInsuranceOptions';
import { createIncoterms } from '@/constants/incoterms';
import { dutyTaxPaymentMethodOptions } from '@/constants/dutyTaxPaymentMethodOptions';

// Mixins
import carriers from '@/mixins/carrierOptions';
import places from '@/mixins/placeOptions';
import vessels from '@/mixins/vesselOptions';

// types
import {
  IncotermsTypeEnum,
  ShipmentDocumentDataInput,
  ShipmentDocumentFields,
  TransportationCargoTypeEnum,
  PriceCategorization
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    UtcDatePicker,
    'el-checkbox': Checkbox,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-option-group': OptionGroup,
    'el-select': Select,
    'el-radio-group': RadioGroup,
    'el-radio': Radio
  }
})
export default class CustomsInformationExport extends Mixins(
  carriers,
  places,
  vessels
) {
  @Prop({ type: Object }) value!: ShipmentDocumentDataInput;
  @Prop({ type: Object }) document!: ShipmentDocumentFields;

  readonly TransportationCargoTypeEnum = TransportationCargoTypeEnum;
  readonly customerInsuranceOptions = customerInsuranceOptions();
  readonly dutyTaxPaymentMethodOptions = dutyTaxPaymentMethodOptions();

  public incotermOptions: SelectOption<any>[] = createIncoterms();

  created() {
    // disable auto select for place select
    this.autoSelect = false;
    // init transport type for place select
    this.transportationType = this.document.data.transportationType;
  }

  get customsArrivalDate() {
    return this.value.customsArrivalDate;
  }

  set customsArrivalDate(data) {
    this.$emit('input', { ...this.value, customsArrivalDate: data });
  }

  get customsClearanceDesiredDate() {
    return this.value.customsClearanceDesiredDate;
  }

  set customsClearanceDesiredDate(data) {
    this.$emit('input', { ...this.value, customsClearanceDesiredDate: data });
  }

  get otherLaws() {
    return this.value.otherLaws;
  }

  set otherLaws(data) {
    this.$emit('input', { ...this.value, otherLaws: data });
  }

  get clientRemarks() {
    return this.value.clientRemarks;
  }

  set clientRemarks(data) {
    this.$emit('input', { ...this.value, clientRemarks: data });
  }

  get freightRemarks() {
    return this.value.freightRemarks;
  }

  set freightRemarks(data) {
    this.$emit('input', { ...this.value, freightRemarks: data });
  }

  get shipmentInvoiceNumber() {
    return this.value.shipmentInvoiceNumber;
  }

  set shipmentInvoiceNumber(data) {
    this.$emit('input', { ...this.value, shipmentInvoiceNumber: data });
  }

  get shipmentIncoterms() {
    return this.value.shipmentIncoterms;
  }

  set shipmentIncoterms(data) {
    this.$emit('input', { ...this.value, shipmentIncoterms: data });
  }

  get priceCategorization() {
    return this.value.priceCategorization;
  }

  set priceCategorization(data) {
    this.$emit('input', { ...this.value, priceCategorization: PriceCategorization[data] });
  }
}
